import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoDpto} value={props.elemento._id}>{props.elemento.descrDpto}</option>
)
};

const Lista = ({handleLista, list}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={handleLista}>
                <option value="">Seleccionar...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};

const DetalleNivel3 = props => {
    return(
        <option dato1={props.elemento.codigoCiudad} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
    )
}

const DetalleNivel2 = ({styles, elemento, handleLista1}) => {
    const Nivel3Detalle = elemento.ciudades.map((elemento, i) => <DetalleNivel3 styles={styles} elemento={elemento} key={i} />);
    return (
        <select className="ui simple selection dropdown fluid" name="dpto" id="miLista1" onChange={handleLista1}>
        <option value="">Seleccionar...</option>
        {Nivel3Detalle}
    </select>
    )
  };

const ListaCi = ({handleLista1, list, argsSelDpto}) => {
    var Nivel2Detalle = []
    list.forEach((elemento, _id) => {
        if(elemento._id===argsSelDpto._id){
            let niv2Det = []
            niv2Det.push(elemento)
            Nivel2Detalle = niv2Det.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} handleLista1={handleLista1}/>);
        }
    })
    return(
        <div>
            {!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar..." ?
                <select className="ui simple selection dropdown fluid" name="dpto" id="miLista1" onChange={handleLista1}>
                    <option value="">Seleccionar...</option>
                    {Nivel2Detalle}
                </select>
            :
                <div>
                    {Nivel2Detalle}
                </div>
            }
        </div>
    )
};

const AddZon2 = ({styles, list, handleLista, handleLista1, handleSubmit, handleChange, args, argsSelDpto, errors}) => {

    return(
        <div>
            <button className="ui right labeled icon button" style={styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                Zona nueva
            </button>
            <div style={styles.box}>
                <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                    <div className="ui one column stackable grid">
                            <div className="row container">
                                <div className="column" width="100%">
                                <Form.Field>
                                    <label style={styles.label}>Código</label>
                                    <Form.Input autoComplete="off" name="codigoZona" id="codigoZona" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoZona'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Descripción</label>
                                    <Form.Input autoComplete="off" name="nombreZona" id="nombreZona" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'nombreZona'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Departamento</label>
                                    <Lista list={list} styles={styles} handleLista={handleLista} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Ciudad</label>
                                    <ListaCi list={list} styles={styles} handleLista1={handleLista1} argsSelDpto={argsSelDpto}/>
                                </Form.Field>

                                <Button type='submit' primary fluid>
                                    Agregar
                                </Button>

                                {
                                    errors.length?<Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AddZon2
